/* Worksheets stay in this document. No storage, network, enrollment, or score threshold. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.fdInitialized) return;
    root.dataset.fdInitialized = 'true';
    var task = root.querySelector('[data-fd-task]');
    var list = root.querySelector('[data-fd-summary-list]');
    var pending = root.querySelector('[data-fd-pending-list]');
    function row(target, label, answer) {
      var li = document.createElement('li');
      var strong = document.createElement('strong');
      strong.textContent = label + ': ';
      li.appendChild(strong);
      li.appendChild(document.createTextNode(answer));
      target.appendChild(li);
    }
    function update() {
      list.replaceChildren();
      if (pending) pending.replaceChildren();
      root.querySelector('[data-fd-task-output]').textContent = task.value;
      var ready = 0;
      root.querySelectorAll('[data-fd-item]').forEach(function (item) {
        var answer = item.querySelector('input:checked');
        if (pending) {
          if (answer && answer.value === '0') {
            ready += 1;
            row(list, item.dataset.fdItem, answer.dataset.fdAnswer);
          } else {
            row(pending, item.dataset.fdItem, answer ? answer.dataset.fdAnswer : '');
          }
        } else if (answer) {
          row(list, item.dataset.fdItem, answer.dataset.fdAnswer);
        }
      });
      var count = root.querySelector('[data-fd-count]');
      if (count) count.textContent = ready + ' / 6';
    }
    root.addEventListener('input', update);
    root.addEventListener('change', update);
    update();
  }
  function continueAfterSuccess() {
    // Shopify must render success on this same route before PR 530 can correlate it.
    // Only a published destination renders an anchor. The anchor also works without JS.
    var success = document.querySelector('.fd-success[data-ow-sent]');
    var next = success && success.querySelector('a[href]');
    if (!next || success.dataset.fdRedirectScheduled || document.querySelector('[data-ow-error]')) return;
    success.dataset.fdRedirectScheduled = 'true';
    window.setTimeout(function () { window.location.assign(next.href); }, 4000);
  }
  function scan() { document.querySelectorAll('[data-fd-worksheet]').forEach(init); }
  if (document.readyState === 'complete') continueAfterSuccess();
  else window.addEventListener('load', continueAfterSuccess, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
}());
